import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRadiation } from '@fortawesome/free-solid-svg-icons';

const TIER_CONFIG = {
    gold: { colorClass: 'ceremony-card--gold' },
    titanium: { colorClass: 'ceremony-card--titanium' },
    uranium: { colorClass: 'ceremony-card--uranium' },
};

const CeremonyCard = ({ tier, phase }) => {
    if (!tier) return null;
    const config = TIER_CONFIG[tier];
    const isFlipping = phase === 'flip' || phase === 'settle';

    return (
        <div className={`ceremony-card ${config.colorClass} ceremony-card--${phase}`}>
            <div className={`ceremony-card__face ${isFlipping ? 'ceremony-card__face--flipping' : ''}`}>
                {tier === 'uranium' && (
                    <div className="ceremony-card__trefoil">
                        <FontAwesomeIcon icon={faRadiation} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CeremonyCard;
